export default __webpack_public_path__ + "static/media/madra-eye.fd4145c4.png";